import { ThemeProvider } from '@material-ui/core';
import { setBaseUrl, setTenantId } from '@swyft/questionnaire';
import { BaseMuiTheme } from '@theme';
import { AppProvider } from '@utils/appState';
import { QueryClient, QueryClientProvider } from 'react-query';
import { runtimeConfig } from './config';
import { AppRoutes } from './routes';

setBaseUrl(runtimeConfig.api.baseUrl);
setTenantId(runtimeConfig.api.tenantId);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 10_000
    }
  }
});

export function App(): JSX.Element {
  return (
    <ThemeProvider theme={BaseMuiTheme}>
      <QueryClientProvider client={queryClient}>
        <AppProvider>
          <AppRoutes />
        </AppProvider>
      </QueryClientProvider>
    </ThemeProvider>
  );
}
